class HelpcenterSearch {
  constructor(helpcenterSearch) {
    this.html = document.documentElement;
    this.search = helpcenterSearch.querySelector('d4l-search');
    this.helpcenters = [...document.querySelectorAll('.js-helpcenter')];
    this.accordions = [...document.querySelectorAll('.helpcenter .js-accordion')];
    this.searchStatus = helpcenterSearch.querySelector('.helpcenter-search__status');

    this.CLASSES = {
      SEARCH_ACTIVE: 'helpcenter-search-active',
      HELPCENTER_FOUND: 'helpcenter--found',
      HELPCENTER_ITEM_FOUND: 'helpcenter__item--found',
    };

    // Stop if neither helpcenter-search nor helpcenter-generator are on same page
    if (!this.accordions) {
      return;
    }

    this.search.handleInput = (event) => {
      clearTimeout(this.timer);
      const query = event.query.join(' ');

      if (!query || query.length <= 2) {
        if (this.needsReset) {
          this.reset();
        }
        return;
      }

      // Debounce
      this.timer = setTimeout(() => {
        this.query(this.escapeRegExp(query));
      }, 300);
    };
  }

  escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  resetHighlight(item) {
    const elements = [item.querySelector('summary'), item.querySelector('.accordion__content-inner')];
    elements.forEach((e) => {
      e.innerHTML = e.innerHTML.replace(/<mark>/g, '');
    });
  }

  reset() {
    this.needsReset = false;
    this.html.classList.remove(this.CLASSES.SEARCH_ACTIVE);
    this.accordions.forEach((item) => {
      if (item.querySelector('details').open) {
        item.querySelector('summary').click();
      }
      item.parentElement.classList.remove(this.CLASSES.HELPCENTER_FOUND);
      item.classList.remove(this.CLASSES.HELPCENTER_ITEM_FOUND);
      this.resetHighlight(item);
    });
  }

  handleResultMessage() {
    // Translation object added in helpcenter-search.php
    const trans = window.hcSearchTranslations || {};
    const message = this.totalResults > 0 ? trans.resultsFound : trans.noResults;
    this.searchStatus.textContent = message;
  }

  query(query) {
    this.needsReset = true;
    this.totalResults = 0;

    this.helpcenters.forEach((hc) => {
      hc.classList.remove(this.CLASSES.HELPCENTER_FOUND);

      // Query always triumph over filters
      hc.classList.remove('helpcenter--filtered');
      hc.querySelector('.helpcenter__filter-tags button[data-query=""]').click();
    });

    const match = new RegExp('(?!</?[^>]*|&[^;]*)(' + query + ')(?![^<]*>)', 'gi');

    this.accordions.forEach((item) => {
      this.resetHighlight(item);

      const elements = [item.querySelector('summary'), item.querySelector('.accordion__content-inner')];
      elements.forEach((e) => {
        e.innerHTML = e.innerHTML.replace(match, '<mark>$&</mark>');
      });

      const termFound = item.querySelector('mark');
      if (termFound) {
        this.totalResults++;
      }
      item.classList.toggle(this.CLASSES.HELPCENTER_ITEM_FOUND, termFound);

      const helpcenter = item.parentElement;
      if (termFound && !helpcenter.classList.contains(this.CLASSES.HELPCENTER_FOUND)) {
        helpcenter.classList.add(this.CLASSES.HELPCENTER_FOUND);
      }

      if (!item.querySelector('details').open) {
        item.querySelector('summary').click();
      }
    });

    this.handleResultMessage();
    this.html.classList.add(this.CLASSES.SEARCH_ACTIVE);
  }
}

const init = () => {
  [...document.querySelectorAll('.js-helpcenterSearch')].forEach((el) => new HelpcenterSearch(el));
};

export { init };
